exports.components = {
  "component---src-components-templates-winners-template-jsx": () => import("./../../../src/components/templates/winners-template.jsx" /* webpackChunkName: "component---src-components-templates-winners-template-jsx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

